(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react")) : factory(root["react"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE_5__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cancelWatch__ = __webpack_require__(1);
var readNfcTag=function readNfcTag(){var timeout=arguments.length>0&&arguments[0]!==undefined?arguments[0]:15;var readCallback=arguments.length>1&&arguments[1]!==undefined?arguments[1]:function(){};var readOnce=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;navigator.nfc.watch(function(message){console.log('Tag read.\n            First record: '+JSON.stringify(message.records[0])+'\n            Url: '+message.url+'\n            ');readCallback(message.records);if(readOnce){Object(__WEBPACK_IMPORTED_MODULE_0__cancelWatch__["a" /* default */])();}},{mode:'any'}).then(function(watchId){console.log('Started watching for a nfc tag');setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_0__cancelWatch__["a" /* default */])(watchId);},timeout*1000);});};/* harmony default export */ __webpack_exports__["a"] = (readNfcTag);

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var cancelWatch=function cancelWatch(watchId){navigator.nfc.cancelWatch(watchId).then(function(){console.log('Watching for a nfc tag cancelled.');}).catch(function(error){if(error.name==='NotFoundError'){// we're ignoring NotFoundError, assuming it happened because the
// watch was already cancelled after a write
return;}throw error;});};/* harmony default export */ __webpack_exports__["a"] = (cancelWatch);

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(3);


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Nfc__ = __webpack_require__(4);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Nfc", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Nfc__["a"]; });
/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__components_Nfc__["a" /* default */]);

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_readNfcTag__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_writeNfcTag__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * API:
 * const App = () => (
 *   // reading
 *   <div>Tap to a tag to read it</div>
 *   <Nfc read={(data) => {console.log(data)}} />
 *
 *   // writing
 *   <div>Tap to a tag to write to it</div>
 *   <Nfc write='some_data' writeCallback={(error) => {}} />
 * )
 *
 */var Nfc=function(_Component){_inherits(Nfc,_Component);function Nfc(props){_classCallCheck(this,Nfc);var _this=_possibleConstructorReturn(this,(Nfc.__proto__||Object.getPrototypeOf(Nfc)).call(this,props));if(typeof navigator.nfc==='undefined'){throw new Error('Sorry, your device does not support NFC');}return _this;}_createClass(Nfc,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,timeout=_props.timeout,read=_props.read,write=_props.write,writeCallback=_props.writeCallback;if(read&&write){throw new Error('It is not possible to read and write at the same time :(');}if(read){Object(__WEBPACK_IMPORTED_MODULE_1__helpers_readNfcTag__["a" /* default */])(timeout,read);}else if(write){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_writeNfcTag__["a" /* default */])(timeout,write,writeCallback);}}},{key:'render',value:function render(){return null;}}]);return Nfc;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Nfc.defaultProps={timeout:10};/* harmony default export */ __webpack_exports__["a"] = (Nfc);

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__readNfcTag__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cancelWatch__ = __webpack_require__(1);
var writeNfcTag=function writeNfcTag(){var timeout=arguments.length>0&&arguments[0]!==undefined?arguments[0]:15;var data=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var writeCallback=arguments.length>2&&arguments[2]!==undefined?arguments[2]:function(){};Object(__WEBPACK_IMPORTED_MODULE_0__readNfcTag__["a" /* default */])(timeout,function(){var newRecord={data:data};navigator.nfc.push({records:[newRecord]}).then(function(){console.log('Tag successfully written.');Object(__WEBPACK_IMPORTED_MODULE_1__cancelWatch__["a" /* default */])();writeCallback();}).catch(function(error){console.log('Could not write to tag. Error: ',error);writeCallback(error);});},false);};/* harmony default export */ __webpack_exports__["a"] = (writeNfcTag);

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// index.js